import React from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { Box, Typography } from "@mui/material";

import GoBack from "../../assets/images/GoBack.svg";

import ApplicableMandis from "./components/ApplicableMandis";
import ContactsList from "./components/ContactsList";
import InstantReward from "./components/InstantReward";
import MunafaPoster from "./components/MunafaPoster";
import SeasonEndRewards from "./components/SeasonEndRewards";
import TermsCard from "./components/TermsCard";
import WhoCanJoin from "./components/WhoCanJoin";

const ReferralDetails = () => {
  const navigate = useNavigate();
  const isIOSApp = () => Capacitor.getPlatform() === "ios";

  const handleGoBack = () => {
    navigate(-1);

   
    
  };

  return (
    <Box
      sx={{
        bgcolor: "#F6F8FA",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          width: "100%",
          background: `
            linear-gradient(180deg, rgba(114, 190, 184, 0.24) 0%, rgba(255, 255, 255, 0) 100%),
            #F6F8FA
          `,
          pt: isIOSApp() ? 6 : 4,
          pb: 1,
          minHeight: isIOSApp() ? "100px" : "80px",
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "400px",
            display: "flex",
            alignItems: "center",
            margin: "0 auto",
            mt: isIOSApp() ? 1 : 0,
          }}
        >
          <Box
            onClick={handleGoBack}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginLeft: "14px",
              cursor: "pointer",
            }}
          >
            <img src={GoBack} alt="Go back" />
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                paddingLeft: "8px",
                fontSize: "16px",
                color: "#000000",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              Go back
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          pt: 0.5,
          pb: 2,
        }}
      >
        <MunafaPoster />
        <InstantReward />
        <SeasonEndRewards />
        <WhoCanJoin />
        <ApplicableMandis />
        <ContactsList />
        <TermsCard />
      </Box>
    </Box>
  );
};

export default ReferralDetails;